module.exports = __webpack_public_path__ + "static/img/screenshot-bg-blue.11b0a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-bg-blue.png
// module id = 3DGJ
// module chunks = 0